import { render, staticRenderFns } from "./AlmoxarifadoCentralModal.vue?vue&type=template&id=27402708"
import script from "./AlmoxarifadoCentralModal.vue?vue&type=script&lang=js"
export * from "./AlmoxarifadoCentralModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports